import "./Matching.css";
import MatchingUsage from '../../premium/MatchingUsage';
import MatchCard from "./MatchCard";
import { fetchSuggestedProfiles } from "./suggestedProfiles";
import SuggestionRow from "./SuggestionRow";
import { get } from "../../http/api";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";


export default function Matching() {

  const [matches, setMatches] = useState([]);
  const [loadingMatches, setLoadingMatches] = useState(true);
  const [loadingSuggestions, setLoadingSuggestions] = useState(true);

  const [suggestions, setSuggestions] = useState([]);
  const [matchSearch, setMatchSearch] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    loadSuggestions();
  }, []);

  const loadSuggestions = async () => {
    try {
      const data = await fetchSuggestedProfiles();
      setSuggestions(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingSuggestions(false);
    }
  };

  useEffect(() => {
    fetchMatches();
  }, []);


  const fetchMatches = async () => {
    try {
      const res = await get("matches");
      setMatches(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingMatches(false);
    }
  };

  const filteredMatches = matches.filter((profile) => {
    const searchableProfile = [
      profile.full_name,
      profile.name,
      profile.username,
      profile.role,
      profile.sport,
      profile.position,
      profile.country,
      profile.level
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchableProfile.includes(matchSearch.trim().toLowerCase());
  });


  return (
    <div className="matching-page">
      <MatchingUsage />

      <header className="matching-hero matching-header">
        <h1>{t("matching.suggestionsTitle")}</h1>
        <p>
          {t("matching.suggestionsSubtitle")}
        </p>
      </header>

      <section className="matching-section matching-suggestions-section">
        <SuggestionRow profiles={suggestions} loading={loadingSuggestions} />
      </section>

      <section className="matching-section matching-confirmed-section">
      <div className="matching-header">
        <h1>{t("matching.matchesTitle")}</h1>
        <p>
          {t("matching.matchesSubtitle")}
        </p>
      </div>

      <div className="matching-list-toolbar">
        <div className="matching-search">
          <FaSearch />
          <input
            type="search"
            value={matchSearch}
            onChange={(event) => setMatchSearch(event.target.value)}
            placeholder={t("conversations.search")}
            aria-label={t("conversations.search")}
          />
        </div>
      </div>

      <div className="matching-list-scroll">
      <div className="matching-grid matching-list">

        {loadingMatches
          ? Array.from({ length: 3 }).map((_, i) => (
            <MatchCard key={i} loading={true} />
          ))
          : filteredMatches.map(profile => (
            <MatchCard key={profile.id_user} profile={profile} />
          ))
        }

        {!loadingMatches && filteredMatches.length === 0 && (
          <p className="matching-empty-state">
            {t("matching.noMatches")}
          </p>
        )}
      </div>
      </div>
      </section>

    </div>
  );
}
